__turbopack_context__.v({
  "card": "ListItemCard-module__t7_C4W__card",
  "cardContent": "ListItemCard-module__t7_C4W__cardContent",
  "contextMenuSlot": "ListItemCard-module__t7_C4W__contextMenuSlot",
  "detailsContainer": "ListItemCard-module__t7_C4W__detailsContainer",
  "infoContainer": "ListItemCard-module__t7_C4W__infoContainer",
  "interactiveCard": "ListItemCard-module__t7_C4W__interactiveCard",
  "mainContent": "ListItemCard-module__t7_C4W__mainContent",
  "matches": "ListItemCard-module__t7_C4W__matches",
});
